import React, { useEffect, useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { useAuthProvider } from '@maui-mf/common-react'
import { getVirusTotalIndicatorLink } from '@nautilusjs/mati-shared'

export const withVirusTotalIndicatorRedirect = Component => {
  const HOC = props => {
    const { type, value } = useParams()
    const { isGTI } = useAuthProvider()

    const redirectLink = useMemo(() => {
      return isGTI ? getVirusTotalIndicatorLink(type, value) : undefined
    }, [isGTI, type, value])

    useEffect(() => {
      if (redirectLink) {
        window.location.href = redirectLink
      }
    }, [
      redirectLink,
    ])

    return redirectLink ? null : <Component {...props} />
  }

  const componentName = Component.displayName || Component.name || 'Component'
  HOC.displayName = `withVirusTotalIndicatorRedirect(${componentName})`

  return HOC
}
